var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "15 -3 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_3077_9219)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    width: 33,
    height: 33,
    rx: 8.72727,
    fill: "#38D200"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 14.3178C27 9.71789 30.8439 6 35.4934 6C40.1561 6 44 9.71789 44 14.3178C44 16.6357 43.157 18.7876 41.7695 20.6116C40.2388 22.6235 38.3522 24.3765 36.2285 25.7524C35.7425 26.0704 35.3039 26.0944 34.7704 25.7524C32.6347 24.3765 30.7481 22.6235 29.2305 20.6116C27.842 18.7876 27 16.6357 27 14.3178ZM32.6942 14.5768C32.6942 16.1177 33.9517 17.3297 35.4934 17.3297C37.0362 17.3297 38.3058 16.1177 38.3058 14.5768C38.3058 13.0478 37.0362 11.7768 35.4934 11.7768C33.9517 11.7768 32.6942 13.0478 32.6942 14.5768Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_3077_9219",
    x: 0.4,
    y: -4.36364,
    width: 70.2,
    height: 75.1636,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.18182
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3077_9219"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 9,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_3077_9219"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0235294 0 0 0 0 0.290196 0 0 0 0 0.576471 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_3077_9219",
    result: "effect2_dropShadow_3077_9219"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3077_9219",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandmark);
export default __webpack_public_path__ + "static/media/landmark.4506ddf192bf279a9f1045ed56a78074.svg";
export { ForwardRef as ReactComponent };